import React from "react";
import { Tooltip } from "antd";

import { SearchOutlined } from "@ant-design/icons";

interface TableHeaderProps {
  title: string;
  tooltipTitle: string;
  onClickFn: (mnemonic: string) => void;
  mnemonic: string;
  additionalIcon?: boolean;
}

const TableHeader: React.FC<TableHeaderProps> = ({
  title,
  tooltipTitle,
  onClickFn,
  mnemonic,
  additionalIcon = true,
}) => (
  <Tooltip title={tooltipTitle}>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        gap: 8,
        alignItems: "center",
      }}
      onClick={() => {
        onClickFn(mnemonic);
      }}
    >
      {title}
      {additionalIcon && <SearchOutlined />}
    </div>
  </Tooltip>
);

export default TableHeader;
